// extracted by mini-css-extract-plugin
module.exports = {"app":"Bb","modalOpened":"Bd"};